import React, { useEffect, useState } from 'react'
import "./home/index.css";
import { postData } from "./common/utils";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';


const Analytics = () => {

  const [totalPostCount, setTotalPostCount] = useState(0);
  const [totalPatsGiven, setTotalPatsGiven] = useState(0);
  const [avgPatsGiven, setAvgPatsGiven] = useState(0);
  const [team, setTeam] = useState("organization");
  const [allDept, setAllDept] = useState([]);
  const [topUsers, setTopUsers] = useState([]);
  const [topTeams, setTopTeams] = useState([]);
  const [topHashtags, setTopHashtags] = useState([]);
  const [totalMonthlyPatsGiven, setTotalMonthlyPatsGiven] = useState(0);
  const [totalMonthlyPatsSpent, setTotalMonthlyPatsSpent] = useState(0);
  const [totalPatsUtilized, setTotalPatsUtilized] = useState(0);
  const [totalRedeemablePats, setTotalRedeemablePats] = useState(0);
  const [mostAppreciated, setMostAppreciated] = useState([]);
  const [mostAppreciated2, setMostAppreciated2] = useState([]);
  const [totalTeamPostCount, setTotalTeamPostCount] = useState(0);
  const [totalTeamPatsGiven, setTotalTeamPatsGiven] = useState(0);
  const [totalTeamMonthlyPatsGiven, setTotalTeamMonthlyPatsGiven] = useState(0);
  const [totalTeamMonthlyPatsSpent, setTotalTeamMonthlyPatsSpent] = useState(0);
  const [totalTeamPatsUtilized, setTotalTeamPatsUtilized] = useState(0);
  const [teamTop3Users, setTeamTop3Users] = useState([]);
  const [mostTeamAppreciated, setMostTeamAppreciated] = useState([]);
  const [mostTeamAppreciated2, setMostTeamAppreciated2] = useState([]);
  const [accessToken, setAccessToken] = useState("");
  //const { URLSearchParams } = require('url');

  const SelectedTeam = () => {
    var data = {
      team: team
    }
    postData(
      process.env.REACT_APP_API_URL + "api/analytics/selectedteam",
      data
    )
      .then((data) => {
        //console.log("analytics user", data);
        if (data.issuccessful == true) {
          setTotalTeamPostCount(data.teampostcount);
          setTotalTeamPatsGiven(data.teampatscount);
          setTotalTeamMonthlyPatsGiven(data.teamtotalMonthlyPats);
          setTotalTeamMonthlyPatsSpent(data.teammonthlypatscount);
          setTotalTeamPatsUtilized(data.teammonthlypatsUtilized);
          setTeamTop3Users(data.teamtop3);
          setMostTeamAppreciated(data.topappreciatedpats);
          setMostTeamAppreciated2(data.topappreciatedpost);
        }
      });

  }
  useEffect(() => {

    fetch(process.env.REACT_APP_API_URL + "api/analytics/org")
      .then((response) => response.json())
      .then((data) => {
        // console.log("analytics org", data);
        if (data.issuccessful == true) {
          setTotalPostCount(data.orgpostcount);
          setTotalPatsGiven(data.orgpatscount);
          setTotalRedeemablePats(data.totalredeemablepats);
        }
      });


    fetch(process.env.REACT_APP_API_URL + "api/analytics/dept")
      .then((response) => response.json())
      .then((data) => {
        //console.log("analytics dept", data);
        if (data.issuccessful == true) {
          setAllDept(data.dept);
        }
      });

    fetch(process.env.REACT_APP_API_URL + "api/analytics/org/leaderboard")
      .then((response) => response.json())
      .then((data) => {
        // console.log("analytics dept", data);
        if (data.issuccessful == true) {
          setTopUsers(data.statsuser);
          setTopTeams(data.statsteam);
          setTopHashtags(data.statsbadge);
        }
      });

    fetch(process.env.REACT_APP_API_URL + "api/analytics/org/monthlypatsused")
      .then((response) => response.json())
      .then((data) => {
        //console.log("analytics dept", data);
        if (data.issuccessful == true) {
          setTotalMonthlyPatsGiven(data.totalMonthlyPats);
          setTotalMonthlyPatsSpent(data.patscount);
          setTotalPatsUtilized(data.patsUtilized);
        }
      });

    fetch(process.env.REACT_APP_API_URL + "api/analytics/org/mostappreciated")
      .then((response) => response.json())
      .then((data) => {
        //console.log("analytics top", data);
        if (data.issuccessful == true) {
          setMostAppreciated(data.top);
          setMostAppreciated2(data.post);
          //console.log('')
        }
      });

  }, [])

  useEffect(() => {
    //console.log('yesys', team);
    SelectedTeam();
  }, [team])


  const TopUsers = (props) => {

    return (

      topUsers.map((element, index) => {
        return (
          <p>{element.userName}&nbsp;&nbsp;&nbsp;{element.totalPosts}   </p>
        );
      })
    );
  }

  const TopTeams = (props) => {

    return (

      topTeams.map((element, index) => {
        return (
          <p>{element.userTeam}&nbsp;&nbsp;&nbsp;{element.totalPosts}   </p>
        );
      })
    );
  }

  const TopHashtags = (props) => {

    return (

      topHashtags.map((element, index) => {
        return (
          <p>#{element.badgeText}&nbsp;&nbsp;&nbsp;{element.totalbadge}  </p>
        );
      })
    );
  }

  const MostAppreciated = () => {

    //console.log('yeeeeeeeeeet',mostAppreciated );
    return (

      mostAppreciated.map((element, index) => {
        return (
          <p>{element.userName}&nbsp;&nbsp;&nbsp;{element.totalPatsReceived}  </p>
        );
      })
    );
  }

  const MostAppreciated2 = () => {

    //console.log('yeeeeeeeeeet',mostAppreciated );
    return (

      mostAppreciated2.map((element, index) => {
        return (
          <p>{element.userName}&nbsp;&nbsp;&nbsp;{element.totalPosts}  </p>
        );
      })
    );
  }



  const Departments = () => {

    //console.log('yeeeeeeeeeet',mostAppreciated );
    return (
      <select onChange={(e) => setTeam(e.target.value)} value={team} style={{ marginBottom: "30px", width: "30%", outline: "none", border: "none", borderRadius: "8px", boxShadow: "0px 0px 17px -6px black", padding: "8px" }}>
        {/* <option value= "" selected>Select Team</option> */}
        <option value="organization" selected>Organization</option>
        {allDept.map((element, index) => {
          return (
            <option value={element.DeptName}>{element.DeptName}</option>
          );
        })}
      </select>
    );
  }

  const TeamTop3Users = (props) => {

    return (

      teamTop3Users.map((element, index) => {
        return (
          <p>{element.userName}&nbsp;&nbsp;&nbsp;{element.totalPosts}   </p>
        );
      })
    );
  }

  const TeamMostAppreciated = () => {

    //console.log('yeeeeeeeeeet',mostAppreciated );
    return (

      mostTeamAppreciated.map((element, index) => {
        return (
          <p>{element.userName}&nbsp;&nbsp;&nbsp;{element.totalPatsReceived}  </p>
        );
      })
    );
  }

  const TeamMostAppreciated2 = () => {

    //console.log('yeeeeeeeeeet',mostAppreciated );
    return (

      mostTeamAppreciated2.map((element, index) => {
        return (
          <p>{element.userName}&nbsp;&nbsp;&nbsp;{element.totalPosts}  </p>
        );
      })
    );
  }

  const date = new Date();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();


  const reportId = 'fae6951e-2b4d-4500-97ce-e0fc2de5f091';
  const groupId = 'd08670f0-b746-4f67-954d-aa2df48ec48c';

  const accessTokenAPI = () => {

    var urlencoded = "grant_type=password&scope=openid&resource=https://analysis.windows.net/powerbi/api&client_id=7b9df68d-0a19-44ab-9868-1d8fafff50ec&username=noreply@i2econsulting.com&password=mumbai@2020&client_secret=vJc8Q~t36Zcpv.8YTOIcGnxoUYWWWYwOHxmnsbgI";
    var data = {
      //header: myHeaders,
      datastring: urlencoded,
    };
    postData(
      process.env.REACT_APP_API_URL + "api/analytics/getToken",
      data
    ).then((data) => {
      //console.log("token",data.token.access_token);
      setAccessToken(data.token.access_token);
    })

  }

  useEffect(() => {
    accessTokenAPI();

    const interval = setInterval(() => {
      accessTokenAPI();

    }, 3300000);
    return () => clearInterval(interval);


  }, []);

  return (

    <PowerBIEmbed
      embedConfig={{
        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
        id: 'fae6951e-2b4d-4500-97ce-e0fc2de5f091',
        embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=fae6951e-2b4d-4500-97ce-e0fc2de5f091&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
        accessToken: accessToken,
        tokenType: models.TokenType.aad,
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: true
            }
          },
        }
      }}

      eventHandlers={
        new Map([
          ['loaded', function () {
            //console.log('Report loaded'); 
          }],
          ['rendered', function () {
            //console.log('Report rendered'); 
          }],
          ['error', function (event) {
            //console.log(event.detail); 
          }]
        ])
      }

      cssClassName={"Embed-container"}

      getEmbeddedComponent={(embeddedReport) => {
        window.report = embeddedReport;
      }}
    />

    // <>    
    //       <div>
    //         <Departments />
    //         <select style={{marginLeft:"20px",marginBottom:"30px",width:"30%", outline:"none",border:"none",borderRadius:"8px",boxShadow:"0px 0px 17px -6px black",padding:"8px"}}>
    //         <option value="">{month} {year}</option>
    //           <option value="">Jan {year}</option>
    //           <option value="">Feb {year}</option>
    //           <option value="">Mar {year}</option>
    //           <option value="">Apr {year}</option>
    //           <option value="">May {year}</option>
    //           <option value="">Jun {year}</option>
    //           <option value="">Jul {year}</option>
    //           <option value="">Aug {year}</option>
    //           <option value="">Sept {year}</option>
    //           <option value="">Oct {year}</option>
    //           <option value="">Nov {year}</option>
    //           <option value="">Dec {year}</option>   
    //         </select>
    //       </div>

    //       {team == 'organization' && <div>
    //       <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px"}}>
    //           <p>Most Engaged Users - {month}' {year}</p>
    //           <TopUsers/>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p>Most Engaged Teams - {month}' {year}</p>
    //           <TopTeams/>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p>Most Used Hashtags</p>
    //           <TopHashtags/>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <h6 style={{fontWeight:"bold"}}>Monthly Pats stats</h6>
    //           <p>Total Pats Given:&nbsp;&nbsp;&nbsp;{totalMonthlyPatsGiven}</p>
    //           <p>Total Pats Spent:&nbsp;&nbsp;&nbsp;{totalMonthlyPatsSpent}</p>
    //           <p>Pats Utilization:&nbsp;&nbsp;&nbsp;{totalPatsUtilized}%</p>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <h6 style={{fontWeight:"bold"}}>Organization Stats</h6>
    //           <p>Total no. of appreciations:&nbsp;&nbsp;&nbsp;{totalPostCount}</p>
    //           <p>Total no. of pats given:&nbsp;&nbsp;&nbsp;{totalPatsGiven}</p>
    //           <p>Total Redeemable Pats:&nbsp;&nbsp;&nbsp;{totalRedeemablePats}</p>
    //         </div>


    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p>Most Appreciated User- Pats</p>
    //           <MostAppreciated />
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p>Most Appreciated User-posts</p>
    //           <MostAppreciated2 />
    //         </div>



    //       </div>}

    //       {team != 'organization' && <div>
    //       <h2 style={{fontWeight:"bold"}}>{team} Team</h2>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <h6 style={{fontWeight:"bold"}}>Team Stats</h6>
    //           <p>Total no. of appreciations:&nbsp;&nbsp;&nbsp;{totalTeamPostCount}</p>
    //           <p>Total no. of pats given:&nbsp;&nbsp;&nbsp;{totalTeamPatsGiven}</p>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <h6 style={{fontWeight:"bold"}}>Monthly Pats stats</h6>
    //           <p>Total Pats Given:&nbsp;&nbsp;&nbsp;{totalTeamMonthlyPatsGiven}</p>
    //           <p>Total Pats Spent:&nbsp;&nbsp;&nbsp;{totalTeamMonthlyPatsSpent}</p>
    //           <p>Pats Utilization:&nbsp;&nbsp;&nbsp;{totalTeamPatsUtilized}%</p>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p style={{fontWeight:"bold"}}>Most Engaged Users - {month}' {year}</p>
    //           <TeamTop3Users/>
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p style={{fontWeight:"bold"}}>Most Appreciated User- Pats</p>
    //           <TeamMostAppreciated />
    //         </div>

    //         <div style={{backgroundColor:"white",padding:"10px",borderRadius:"10px",marginTop:"20px"}}>
    //           <p style={{fontWeight:"bold"}}>Most Appreciated User-posts</p>
    //           <TeamMostAppreciated2 />
    //         </div>
    //       </div>}

    // </>
    //<iframe title="pats" width="110%" height="500" src="https://app.powerbi.com/reportEmbed?reportId=fae6951e-2b4d-4500-97ce-e0fc2de5f091&autoAuth=true&ctid=44060820-ecc9-4366-b97e-0db725e356db" frameborder="0" allowFullScreen="true"></iframe>
  )
}

export default Analytics